/* eslint-disable */
import Firebase from 'firebase'

// export const firebaseApp = firebase.initializeApp({
//   apiKey: "AIzaSyBDteKFJ_AV7PrY1dSPuS9Uz5A6hyLcAa4",
//   authDomain: "getlocal-staging.firebaseapp.com",
//   databaseURL: "https://getlocal-staging.firebaseio.com",
//   projectId: "getlocal-staging",
//   storageBucket: "getlocal-staging.appspot.com",
//   messagingSenderId: "1023494749118"
// });

export const firebaseApp = firebase.initializeApp({
	apiKey: "AIzaSyCsC4HSuxVYJvs7o2UawwioHRaQLPLEdwg",
    authDomain: "getlocal-dashboard.firebaseapp.com",
    databaseURL: "https://getlocal-dashboard.firebaseio.com",
    projectId: "getlocal-dashboard",
    storageBucket: "getlocal-dashboard.appspot.com",
    messagingSenderId: "366513048132"
});

export const db = firebaseApp.database();
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();



// WEBPACK FOOTER //
// ./src/firebase.js